var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRunFlat = function SvgRunFlat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M6.817 3.5v1.857C4.939 7.511 4 9.633 4 11.724s.939 4.235 2.817 6.432V20.5m10.43-17v1.857C19.081 7.695 20 9.91 20 12s-.918 4.143-2.754 6.156V20.5M6.817 18.156c3.593.511 7.632.576 10.435 0m-5.22-2.656a1 1 0 1 0 .001-2.001 1 1 0 0 0-.001 2.001zm0-4v-7",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgRunFlat as ReactComponent };
export default __webpack_public_path__ + "d412f6de3d68861a3af3b474b56196d2.svg";